import _JSXStyle from "styled-jsx/style";

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

function _iterableToArrayLimit(arr, i) {
  if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return;
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

import React, { useState, useEffect } from 'react';
import Collapse from "./Collapse";
import ClickableContainer from "./ClickableContainer";
import Icon from "./Icon";

var ExpandableSection = function ExpandableSection(_ref) {
  var children = _ref.children,
      className = _ref.className,
      _ref$onToggle = _ref.onToggle,
      onToggle = _ref$onToggle === void 0 ? function () {} : _ref$onToggle,
      defaultOpen = _ref.open,
      title = _ref.title;

  var _useState = useState(defaultOpen),
      _useState2 = _slicedToArray(_useState, 2),
      open = _useState2[0],
      setOpen = _useState2[1];

  useEffect(function () {
    setOpen(defaultOpen);
  }, [defaultOpen]);

  var toggle = function toggle() {
    setOpen(!open);
    onToggle(!open);
  };

  return (
    /*#__PURE__*/
    React.createElement("section", {
      className: className
    },
    /*#__PURE__*/
    React.createElement("header", null,
    /*#__PURE__*/
    React.createElement(ClickableContainer, {
      "aria-expanded": open,
      className: "d-flex align-items-center",
      onClick: toggle
    },
    /*#__PURE__*/
    React.createElement(Icon, {
      name: "chevron-".concat(open ? 'up' : 'down'),
      className: "text-muted mr-1",
      fixedWidth: true,
      style: {
        transition: 'transform 200ms ease-in-out'
      }
    }),
    /*#__PURE__*/
    React.createElement("b", {
      className: "jsx-1710869735"
    }, title),
    /*#__PURE__*/
    React.createElement(_JSXStyle, {
      id: "1710869735"
    }, "b.jsx-1710869735{-webkit-touch-callout:none;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;}"))),
    /*#__PURE__*/
    React.createElement(Collapse, {
      isOpen: open
    },
    /*#__PURE__*/
    React.createElement("div", {
      className: "py-3"
    }, children)))
  );
};

ExpandableSection.displayName = "ExpandableSection";
ExpandableSection.defaultProps = {
  className: '',
  open: false,
  onToggle: function onToggle() {}
};
export default ExpandableSection;